var $b13570399e5d363d$exports = {};
const $b13570399e5d363d$var$nodes = [].slice.call(document.querySelectorAll(".project-grid__item"), 0);
const $b13570399e5d363d$var$directions = {
    0: "top",
    1: "right",
    2: "bottom",
    3: "left"
};
const $b13570399e5d363d$var$classNames = [
    "in",
    "out"
].map((p)=>Object.values($b13570399e5d363d$var$directions).map((d)=>`${p}-${d}`)).reduce((a, b)=>a.concat(b));
function $b13570399e5d363d$var$getDirectionKey(event, node) {
    const { width: width, height: height, top: top, left: left } = node.getBoundingClientRect();
    const l = event.pageX - (left + window.scrollX);
    const t = event.pageY - (top + window.scrollY);
    const x = (l - width / 2) * (width > height ? height / width : 1);
    const y = (t - height / 2) * (height > width ? width / height : 1);
    return Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;
}
class $b13570399e5d363d$var$Item {
    constructor(element){
        this.element = element;
        this.element.addEventListener("mouseover", (event)=>this.update(event, "in"));
        this.element.addEventListener("mouseout", (event)=>this.update(event, "out"));
    }
    update(event, prefix) {
        this.element.classList.remove(...$b13570399e5d363d$var$classNames);
        this.element.classList.add(`${prefix}-${$b13570399e5d363d$var$directions[$b13570399e5d363d$var$getDirectionKey(event, this.element)]}`);
    }
}
$b13570399e5d363d$var$nodes.forEach((node)=>new $b13570399e5d363d$var$Item(node));


//# sourceMappingURL=projects.90382dd3.js.map
